<template>
  <div class="web-video-containter">
    <audio id="cameraAudio" preload="auto">
      <source src="../assets/audio/cameraShutter.mp3" type="audio/mpeg">
      <!-- Fallback for browsers that don't support MP3 -->
    </audio>
    <div class="close-web-camera" @click="close">
      <i  class='bx bx-x'></i>
    </div>
    <div class="switch-camera">
      <div class="switch-camera-wrapper">
        <i class="bx bx-camera" @click="switchCamera"></i>
        <div class="switch-number"> {{(currentCameraMode === 'user') ? 2 : 1}}</div>
      </div>
    </div>
    <template>
      <video
        autoplay
        muted
        playsinline
        webkit-playsinline
        x5-playsinline
        x5-video-player-type="h5"
        x5-video-player-fullscreen="true"
        id="preview"
        :class="{'user-mode': currentCameraMode !== 'environment'}"
        @loadeddata="onVideoLoaded"
        @error="onVideoError"
      ></video>
    </template>

    <div class="actions">
      <div class="" style="flex: 1; text-align: center">
        <button type="button" id="take-photo" :class="{'red-take-photo': isRecording}" class="btn-shot" @click="onTakePhotoClick" tabindex="1"></button>
      </div>
    </div>
  </div>
</template>


<script>
import _ from "lodash";

export default {
  name: "webCamera",
  props:{
    multiple:{
      type: Boolean,
      default: false
    },
    sendAfterTakePhoto:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isRecording: false,
      activeVideoStream: null,
      savedImgCount: 0,
      unsavedImgCount: 0,
      currentCameraMode: 'environment',
      isClickedClose: false,
      blobImages: [],
      base64Images: []
    }
  },
  mounted() {
    // Set viewport height for mobile devices
    this.setMobileViewportHeight();

    this.startVideo();

    // Add orientation change listener for mobile devices
    this.addOrientationChangeListener();

    // Enter fullscreen with delay to allow DOM to be ready
    this.$nextTick(() => {
      setTimeout(() => {
        this.enterFullscreen();
      }, 200);
    });
  },
  beforeDestroy() {
    console.log('Component being destroyed, cleaning up...');

    // Stop video stream
    if (this.activeVideoStream) {
      try {
        this.activeVideoStream.getTracks().forEach(track => track.stop());
        this.activeVideoStream = null;
      } catch (e) {
        console.warn('Error stopping video stream in beforeDestroy:', e);
      }
    }

    // Remove orientation change listener
    this.removeOrientationChangeListener();


    // Exit fullscreen if active
    const isCurrentlyFullscreen = document.fullscreenElement ||
                                 document.webkitFullscreenElement ||
                                 document.mozFullScreenElement ||
                                 document.msFullscreenElement;

    if (isCurrentlyFullscreen) {
      const exitFullscreen = document.exitFullscreen ||
                            document.webkitExitFullscreen ||
                            document.mozCancelFullScreen ||
                            document.msExitFullscreen;

      if (exitFullscreen) {
        exitFullscreen.call(document).catch(e => {
          console.warn('Error exiting fullscreen in beforeDestroy:', e);
        });
      }
    }
  },
  computed: {

  },
  methods: {
    close() {
      console.log('Close button clicked');
      console.log('savedImgCount:', this.savedImgCount, 'unsavedImgCount:', this.unsavedImgCount);

      // Stop video stream first
      if (this.activeVideoStream) {
        try {
          this.activeVideoStream.getTracks().forEach(track => track.stop());
          this.activeVideoStream = null;
        } catch (e) {
          console.warn('Error stopping video stream:', e);
        }
      }

      // Exit fullscreen before closing
      this.exitFullscreen().then(() => {
        // Convert blobs to base64 before closing
        this.convertAndClose();
      });
    },
// Android fullscreen optimization methods
    setMobileViewportHeight() {
      // Set CSS custom property for mobile viewport height
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);

      // Update on resize
      window.addEventListener('resize', () => {
        const vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
      });
    },

    enterFullscreen() {
      // Detect if we're on Android
      const isAndroid = /Android/i.test(navigator.userAgent);
      const isMobile = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

      console.log('Entering fullscreen - Android:', isAndroid, 'Mobile:', isMobile);

      // Always use CSS-based approach for mobile devices
      if (isMobile) {
        this.enterMobileFullscreen();
      } else {
        // Try native fullscreen for desktop
        this.enterDesktopFullscreen();
      }
    },

    enterMobileFullscreen() {
      console.log('Entering mobile fullscreen mode');

      // Add mobile fullscreen class
      const container = this.$el;
      if (container) {
        container.classList.add('mobile-fullscreen');
      }

      // Hide browser UI
      this.hideMobileBrowserUI();

      // Lock orientation if possible
      this.lockOrientation();
    },

    enterDesktopFullscreen() {
      const element = document.documentElement;
      const requestFullscreen = element.requestFullscreen ||
          element.webkitRequestFullscreen ||
          element.mozRequestFullScreen ||
          element.msRequestFullscreen;

      if (requestFullscreen) {
        requestFullscreen.call(element).catch(e => {
          console.warn('Desktop fullscreen failed:', e);
          this.enterMobileFullscreen(); // Fallback to CSS
        });
      } else {
        this.enterMobileFullscreen(); // Fallback to CSS
      }
    },

    hideMobileBrowserUI() {
      // Hide address bar on mobile
      window.scrollTo(0, 1);

      // Additional mobile browser UI hiding
      if (window.screen && window.screen.orientation) {
        try {
          // Modern browsers
          if (document.documentElement.requestFullscreen) {
            document.documentElement.requestFullscreen().catch(() => {
              console.log('Fullscreen request ignored (expected on mobile)');
            });
          }
        } catch (e) {
          console.log('Fullscreen not available:', e);
        }
      }
    },

    lockOrientation() {
      // Try to lock orientation to portrait for better camera experience
      if (screen.orientation && screen.orientation.lock) {
        screen.orientation.lock('portrait').catch(e => {
          console.log('Orientation lock not available:', e);
        });
      }
    },
    // Simplified fullscreen exit method
    exitFullscreen() {
      return new Promise((resolve) => {
        // Remove mobile fullscreen classes
        const container = this.$el;
        if (container) {
          container.classList.remove('mobile-fullscreen', 'android-fullscreen', 'css-fullscreen');
        }

        // Check if we're in native fullscreen
        const isCurrentlyFullscreen = document.fullscreenElement ||
                                     document.webkitFullscreenElement ||
                                     document.mozFullScreenElement ||
                                     document.msFullscreenElement;

        if (isCurrentlyFullscreen) {
          const exitFullscreen = document.exitFullscreen ||
                                document.webkitExitFullscreen ||
                                document.mozCancelFullScreen ||
                                document.msExitFullscreen;

          if (exitFullscreen) {
            exitFullscreen.call(document).then(() => {
              console.log('Native fullscreen exited successfully');
              resolve();
            }).catch((e) => {
              console.warn('Error exiting native fullscreen:', e);
              resolve(); // Still resolve to continue closing
            });
          } else {
            console.log('exitFullscreen not available');
            resolve();
          }
        } else {
          console.log('Not in native fullscreen mode, CSS classes removed');
          resolve();
        }
      });
    },
    async convertAndSend() {
      try {
        console.log('convertAndSend: Converting', this.blobImages.length, 'blob images to base64...');

        if (this.blobImages.length > 0) {
          this.base64Images = await this.convertBlobsToBase64(this.blobImages);
          console.log('convertAndSend: Converted to base64:', this.base64Images.length, 'images');
        }
        this.$emit('send', this.base64Images);
        this.base64Images = [];

      } catch (error) {
        console.error('convertAndSend; Error converting blobs to base64:', error);
        // Fallback: still close but with empty array
        this.base64Images = [];
        this.$emit('send', this.base64Images);
      } finally {
        this.blobImages = []
      }
    },
    async convertAndClose() {
      try {
        console.log('Converting', this.blobImages.length, 'blob images to base64...');

        if (this.blobImages.length > 0) {
          this.base64Images = await this.convertBlobsToBase64(this.blobImages);
          console.log('Converted to base64:', this.base64Images.length, 'images');
        }

        // Emit close with base64 images
        this.$emit('close', this.base64Images); // Emit base64 images instead of blobs

      } catch (error) {
        console.error('Error converting blobs to base64:', error);
        // Fallback: still close but with empty array
        this.base64Images = [];
        this.$emit('close', this.base64Images); // Emit base64 images instead of blobs
      } finally {
        this.blobImages = []
      }
    },

    // Helper method to handle fullscreen exit and emit close
    exitFullscreenAndClose() {
      console.log('Exiting fullscreen and closing camera');

      // Check if we're currently in fullscreen
      const isCurrentlyFullscreen = document.fullscreenElement ||
                                   document.webkitFullscreenElement ||
                                   document.mozFullScreenElement ||
                                   document.msFullscreenElement;

      if (isCurrentlyFullscreen) {
        // Exit fullscreen first, then emit close
        const exitFullscreen = document.exitFullscreen ||
                              document.webkitExitFullscreen ||
                              document.mozCancelFullScreen ||
                              document.msExitFullscreen;

        if (exitFullscreen) {
          exitFullscreen.call(document).then(() => {
            console.log('Fullscreen exited successfully');
            this.$emit('close', this.base64Images); // Emit base64 images instead of blobs
          }).catch((e) => {
            console.warn('Error exiting fullscreen:', e);
            this.$emit('close', this.base64Images); // Emit base64 images instead of blobs
          });
        } else {
          // Fallback if exitFullscreen is not available
          console.log('exitFullscreen not available, using vue-fullscreen toggle');
          try {
            this.$fullscreen.toggle(document.body, {
              wrap: false,
              callback: () => {
                console.log('Fullscreen toggled, emitting close event');
                this.$emit('close', this.base64Images); // Emit base64 images instead of blobs
              }
            });
          } catch (e) {
            console.warn('Error with fullscreen toggle:', e);
            this.$emit('close', this.base64Images); // Emit base64 images instead of blobs
          }
        }
      } else {
        // Not in fullscreen, just emit close
        console.log('Not in fullscreen, emitting close event directly');
        this.$emit('close', this.base64Images); // Emit base64 images instead of blobs
      }
    },
    emitClose() {
      console.log('emitClose called (deprecated - using inline callback now)');
      if (this.activeVideoStream) {
        this.activeVideoStream.getTracks().forEach(track => track.stop());
      }
      this.$emit('close', this.base64Images);
    },
    onClickDone(id) {
      let data = {}
      let uid = Date.now().toString() + Math.random().toString(36).substr(2, 4)
      data[uid] = {}
      data[uid].image_ids = [id]
      data[uid].imagesSort =[{
        id: id,
        index: 0,
      }]
      // Axios({
      //   method: 'post',
      //   responseType: 'json',
      //   headers: { 'Autosave': true },
      //   url: `/fe/estimate/1`,
      //   validateStatus: function (status) {
      //     return status < 500
      //   },
      //   data: data
      // })
      //     .then((r) => {
      //       if (r.status === 200) {
      //         // this.savedImgCount++
      //       }
      //     })
      //     .finally(() => {
      //       NProgress.done()
      //     })

    },
    switchCamera() {
      this.updateActiveCameraSelection()
    },
    async updateActiveCameraSelection() {
      try {
        this.currentCameraMode = (this.currentCameraMode === 'user') ? 'environment' : 'user';
        this.startVideo()
      } catch (error) {
        this.saveError(error)
      }
    },
    saveError(e) {
      // Axios.post('/fe/logs/front', {error: String(e)}).then(r => {
      // })
    },
    createThumbnail(video, scaleFactor) {
      try {
        if (scaleFactor == null) {
          scaleFactor = 1;
        }

        // Validate video element
        if (!video || !video.videoWidth || !video.videoHeight) {
          console.error('Invalid video element or dimensions');
          return this.createFallbackCanvas();
        }

        let w = video.videoWidth * scaleFactor;
        let h = video.videoHeight * scaleFactor;
        let canvas = document.createElement("canvas");
        canvas.style.margin = "5px";
        canvas.width = w;
        canvas.height = h;

        let ctx = canvas.getContext("2d");

        if (this.currentCameraMode !== 'environment') {
          ctx.translate(w, 0);
          ctx.scale(-1, 1);
        }

        ctx.drawImage(video, 0, 0, w, h);
        return canvas;

      } catch (error) {
        console.error('Error creating thumbnail:', error);
        return this.createFallbackCanvas();
      }
    },

    createFallbackCanvas() {
      // Create fallback canvas when video capture fails
      const canvas = document.createElement('canvas');
      canvas.width = 640;
      canvas.height = 480;
      const ctx = canvas.getContext('2d');

      // Draw placeholder
      ctx.fillStyle = '#f0f0f0';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      ctx.fillStyle = '#999';
      ctx.font = '20px Arial';
      ctx.textAlign = 'center';
      ctx.fillText('Camera Error', canvas.width/2, canvas.height/2);

      return canvas;
    },
    async onTakePhotoClick(e) {
      try {
        e.preventDefault();
        e.stopPropagation();

        this.isRecording = true

        if (window?.navigator?.vibrate) {
          window.navigator.vibrate([200])
        }

        let audio = document.getElementById('cameraAudio');
        if (audio) {
          audio.play().catch(e => {
            console.log('audio.catch:', e);
          });
        }

        let video = document.getElementById("preview");
        let canvas = this.createThumbnail(video, 1);

        // Enhanced blob creation with validation
        canvas.toBlob((blob) => {
          console.log('Canvas toBlob result:', blob);
          console.log('Blob type:', blob?.type);
          console.log('Blob size:', blob?.size);

          setTimeout(() => {
            this.isRecording = false;

            // Check if blob is valid
            if (blob && blob instanceof Blob && blob.size > 0) {
              this.blobImages.push(blob);
              this.savedImgCount++;
            } else {
              console.error('Invalid or null blob, using fallback image');
              this.useFallbackImage();
            }
          }, 100)
        }, 'image/jpeg', 0.8); // Specify format and quality
        if(!this.multiple){
          setTimeout(()=>{
             this.close()
          },1000)
        }else if(this.sendAfterTakePhoto){
          setTimeout(()=>{
            this.convertAndSend()
          },1000)
        }

      } catch (error) {
        this.isRecording = false;
        console.error('Camera capture error:', error);
        this.useFallbackImage();
        this.saveError(error);
      }
    },
    useFallbackImage() {
      // Create a simple placeholder image as base64
      const fallbackImageBase64 = this.createFallbackImage();

      // Convert base64 to blob and add to blobImages
      this.base64ToBlob(fallbackImageBase64).then(blob => {
        this.blobImages.push(blob);
        this.savedImgCount++;
      });

      // Also add directly to base64Images for immediate use
      this.base64Images.push(fallbackImageBase64);

      // Show user notification
      if (this.$toast) {
        this.$toast.warning('Camera unavailable, using placeholder image');
      }
    },

    base64ToBlob(base64Data) {
      return new Promise((resolve) => {
        const byteCharacters = atob(base64Data.split(',')[1]);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'image/jpeg' });
        resolve(blob);
      });
    },

    createFallbackImage() {
      // Create a canvas with accurate VIN plate test image
      const canvas = document.createElement('canvas');
      canvas.width = 640;
      canvas.height = 480;
      const ctx = canvas.getContext('2d');

      // Draw background (dark blue car interior)
      ctx.fillStyle = '#1a2332';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // Draw VIN plate background (metallic silver/white)
      const plateWidth = 320;
      const plateHeight = 200;
      const plateX = (canvas.width - plateWidth) / 2;
      const plateY = (canvas.height - plateHeight) / 2;

      // Gradient background for metallic look
      const gradient = ctx.createLinearGradient(plateX, plateY, plateX, plateY + plateHeight);
      gradient.addColorStop(0, '#f8f8f8');
      gradient.addColorStop(0.5, '#e8e8e8');
      gradient.addColorStop(1, '#d8d8d8');
      ctx.fillStyle = gradient;
      ctx.fillRect(plateX, plateY, plateWidth, plateHeight);

      // Draw border around VIN plate
      ctx.strokeStyle = '#999';
      ctx.lineWidth = 1;
      ctx.strokeRect(plateX, plateY, plateWidth, plateHeight);

      // Add VIN plate text content (black text)
      ctx.fillStyle = '#000';
      ctx.textAlign = 'left';

      // Left column
      ctx.font = 'bold 11px Arial';
      ctx.fillText('VOLKSWAGEN AG', plateX + 15, plateY + 25);

      ctx.font = '9px Arial';
      ctx.fillText('CHASSIS E004727', plateX + 15, plateY + 45);
      ctx.fillText('PAINT    4P4P', plateX + 15, plateY + 60);

      // Center section - VIN number (rotated)
      ctx.save();
      ctx.translate(plateX + 160, plateY + 40);
      ctx.rotate(-Math.PI / 2);
      ctx.font = 'bold 12px monospace';
      ctx.textAlign = 'center';
      ctx.fillText('WVWZZZ3CZGE004727', 0, 0);
      ctx.restore();

      // Right column
      ctx.font = '9px Arial';
      ctx.textAlign = 'left';
      ctx.fillText('JUN 15', plateX + 220, plateY + 25);
      ctx.fillText('BUILT JUN 15', plateX + 220, plateY + 45);

      // Bottom section
      ctx.font = '8px Arial';
      ctx.fillText('MAUF ID 502748', plateX + 15, plateY + 160);

      // VW logo
      ctx.fillStyle = '#1f4e79';
      ctx.beginPath();
      ctx.arc(plateX + 260, plateY + 160, 12, 0, 2 * Math.PI);
      ctx.fill();

      ctx.fillStyle = '#fff';
      ctx.font = 'bold 8px Arial';
      ctx.textAlign = 'center';
      ctx.fillText('VW', plateX + 260, plateY + 164);

      // Part number at bottom
      ctx.fillStyle = '#000';
      ctx.font = '8px monospace';
      ctx.textAlign = 'center';
      ctx.fillText('PA121/02/16BP0036299', plateX + plateWidth/2, plateY + plateHeight - 10);

      // Add "TEST DEFAULT" watermark
      ctx.fillStyle = 'rgba(255, 0, 0, 0.6)';
      ctx.font = 'bold 14px Arial';
      ctx.textAlign = 'center';
      ctx.fillText('TEST DEFAULT', canvas.width/2, canvas.height - 20);

      return canvas.toDataURL('image/jpeg', 0.8);
    },
    async blobToBase64(blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    },

    // Helper function to convert array of blobs to base64 array
    async convertBlobsToBase64(blobs) {
      try {
        const base64Promises = blobs.map(blob => this.blobToBase64(blob));
        const base64Images = await Promise.all(base64Promises);
        return base64Images;
      } catch (error) {
        console.error('Error converting blobs to base64:', error);
        throw error;
      }
    },
    onVideoLoaded() {
      console.log('Video loaded successfully');
    },
    onVideoError(error) {
      console.error('Video error:', error);
      this.handleCameraError(error);
    },
    savePhoto(imageBlob) {
      console.log('Received blob:', imageBlob, 'Type:', typeof imageBlob);

      // Simply store the blob and increment counter
      this.blobImages.push(imageBlob);
      this.savedImgCount++;
    },
    resizeFile(file, width = undefined, height = undefined, quality = 0.7) {
      return new Promise((resolve, reject) => {
        // Add validation
        if (!file || !(file instanceof Blob)) {
          console.error('Invalid blob object:', file);
          reject(new Error('Invalid blob object'));
          return;
        }

        let image = new Image();
        image.src = URL.createObjectURL(file);
        image.onload = function() {
          let imageWidth = image.width;
          let imageHeight = image.height;
          let canvas = document.createElement('canvas');

          if (width && height) {
            canvas.width = width;
            canvas.height = height;
          } else if (width) {
            canvas.width = width;
            canvas.height = Math.floor(imageHeight * width / imageWidth)
          } else if (height) {
            canvas.width = Math.floor(imageWidth * height / imageHeight);
            canvas.height = height;
          } else {
            canvas.width = imageWidth;
            canvas.height = imageHeight
          }

          var ctx = canvas.getContext("2d");
          ctx.drawImage(image, 0, 0, canvas.width, canvas.height);

          let dataUrl = canvas.toDataURL("image/jpeg", quality);

          // Clean up object URL
          URL.revokeObjectURL(image.src);
          resolve(dataUrl);
        }

        image.onerror = function() {
          // Clean up object URL on error
          URL.revokeObjectURL(image.src);
          reject(new Error('Failed to load image'));
        };
      }).then(dataUrl => {
        return dataUrl;
      })
    },
    // Orientation change handling for mobile devices
    addOrientationChangeListener() {
      // Check if device supports orientation events
      if (window.DeviceOrientationEvent || window.OrientationEvent) {
        // Use screen.orientation API if available (modern browsers)
        if (screen.orientation && screen.orientation.addEventListener) {
          screen.orientation.addEventListener('change', this.handleOrientationChange);
        }
        // Fallback to window orientationchange event
        else if (window.addEventListener) {
          window.addEventListener('orientationchange', this.handleOrientationChange);
        }

        console.log('Orientation change listener added');
      }
    },

    removeOrientationChangeListener() {
      // Remove screen.orientation listener
      if (screen.orientation && screen.orientation.removeEventListener) {
        screen.orientation.removeEventListener('change', this.handleOrientationChange);
      }
      // Remove window orientationchange listener
      else if (window.removeEventListener) {
        window.removeEventListener('orientationchange', this.handleOrientationChange);
      }

      console.log('Orientation change listener removed');
    },

    handleOrientationChange() {
      console.log('Orientation changed, restarting video stream...');

      // Delay restart to allow orientation change to complete
      setTimeout(() => {
        if (this.activeVideoStream) {
          this.startVideo();
        }
      }, 500);
    },
    async startVideo() {
      let width = 1280;
      let height = 720;

      // Stop any existing video stream
      if (this.activeVideoStream) {
        try {
          this.activeVideoStream.getTracks().forEach(track => track.stop());
        } catch (e) {
          console.warn('Error stopping existing video stream:', e);
        }
        this.activeVideoStream = null;
      }

      // Check if getUserMedia is supported
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        console.error('getUserMedia not supported');
        this.handleCameraError('Camera not supported on this device');
        return;
      }

      // Detect device type for optimized constraints
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
      const isAndroid = /Android/i.test(navigator.userAgent);
      const isMobile = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

      // Try different camera configurations with fallbacks
      const cameraConfigs = [
        // Primary config with device-optimized resolution
        {
          video: {
            facingMode: this.currentCameraMode,
            width: { ideal: isMobile ? Math.min(width, 1280) : width },
            height: { ideal: isMobile ? Math.min(height, 720) : height },
            ...(isIOS && {
              frameRate: { ideal: 24, max: 30 }, // iOS optimization
              aspectRatio: { ideal: 4/3 } // iOS prefers 4:3
            }),
            ...(isAndroid && {
              frameRate: { ideal: 30, max: 60 }, // Android optimization
              aspectRatio: { ideal: 16/9 } // Android prefers 16:9
            })
          }
        },
        // Fallback 1: Mobile-optimized config
        {
          video: {
            facingMode: this.currentCameraMode,
            width: { min: 320, ideal: 640, max: 1280 },
            height: { min: 240, ideal: 480, max: 720 },
            frameRate: { ideal: isMobile ? 24 : 30 }
          }
        },
        // Fallback 2: Basic config with facing mode only
        {
          video: {
            facingMode: this.currentCameraMode
          }
        },
        // Fallback 3: Any available camera
        {
          video: true
        },
        // Fallback 4: Minimal constraints for problematic devices
        {
          video: {
            width: { ideal: 320 },
            height: { ideal: 240 }
          }
        }
      ];

      for (let i = 0; i < cameraConfigs.length; i++) {
        try {
          console.log(`Trying camera config ${i + 1}:`, cameraConfigs[i]);

          this.activeVideoStream = await navigator.mediaDevices.getUserMedia(cameraConfigs[i]);

          const videoElement = document.getElementById("preview");
          if (videoElement) {
            videoElement.srcObject = this.activeVideoStream;

            // Wait for video to load and verify it's working
            await new Promise((resolve, reject) => {
              const timeout = setTimeout(() => {
                reject(new Error('Video load timeout'));
              }, 8000); // Increased timeout for mobile devices

              videoElement.onloadedmetadata = () => {
                clearTimeout(timeout);
                if (videoElement.videoWidth > 0 && videoElement.videoHeight > 0) {
                  console.log(`Camera started successfully with config ${i + 1}`);

                  // iOS Safari specific: Force video play to ensure proper initialization
                  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
                  if (isIOS) {
                    videoElement.play().catch(e => {
                      console.log('iOS video play ignored:', e);
                    });
                  }

                  resolve();
                } else {
                  reject(new Error('Invalid video dimensions'));
                }
              };

              videoElement.onerror = (e) => {
                clearTimeout(timeout);
                reject(new Error('Video element error: ' + e.message));
              };
            });

            // If we get here, camera is working
            return;
          } else {
            throw new Error('Video element not found');
          }

        } catch (error) {
          console.warn(`Camera config ${i + 1} failed:`, error.name, error.message);

          // Stop the stream if it was created but failed
          if (this.activeVideoStream) {
            try {
              this.activeVideoStream.getTracks().forEach(track => track.stop());
            } catch (e) {
              console.warn('Error stopping failed stream:', e);
            }
            this.activeVideoStream = null;
          }

          // If this is the last config, handle the error
          if (i === cameraConfigs.length - 1) {
            this.handleCameraError(error);
            return;
          }

          // Continue to next config
          continue;
        }
      }
    },

    handleCameraError(error) {
      console.error('All camera configurations failed:', error);

      let userMessage = 'Camera access failed';
      let shouldShowFallback = false;

      // Detect mobile devices for specific error handling
      const isMobile = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
      const isAndroid = /Android/i.test(navigator.userAgent);
      const isPWA = window.matchMedia('(display-mode: standalone)').matches ||
                    window.navigator.standalone === true;

      // Provide specific error messages based on error type and device
      if (error.name === 'NotFoundError' || error.message?.includes('not found')) {
        if (isMobile) {
          userMessage = 'No camera found. Please ensure your device has a camera and try again.';
        } else {
          userMessage = 'No camera device found. Please check if your camera is connected and not being used by another application.';
        }
      } else if (error.name === 'NotAllowedError' || error.message?.includes('denied')) {
        if (isIOS && isPWA) {
          userMessage = 'Camera access denied. In iOS PWA mode, please go to Settings > Safari > Camera and allow access, then restart the app.';
        } else if (isIOS) {
          userMessage = 'Camera access denied. Please allow camera permissions in Safari settings and refresh the page.';
        } else if (isAndroid && isPWA) {
          userMessage = 'Camera access denied. Please allow camera permissions in your browser settings and restart the app.';
        } else if (isAndroid) {
          userMessage = 'Camera access denied. Please allow camera permissions and refresh the page.';
        } else {
          userMessage = 'Camera access denied. Please allow camera permissions and try again.';
        }
        shouldShowFallback = false; // Don't show fallback for permission issues
      } else if (error.name === 'NotReadableError' || error.message?.includes('not readable')) {
        if (isMobile) {
          userMessage = 'Camera is busy. Please close other camera apps and try again.';
        } else {
          userMessage = 'Camera is already in use by another application. Please close other camera apps and try again.';
        }
      } else if (error.name === 'OverconstrainedError') {
        if (isMobile) {
          userMessage = 'Camera settings not supported on this device. Using basic camera mode...';
        } else {
          userMessage = 'Camera settings not supported. Trying with basic settings...';
        }
      } else if (error.message?.includes('timeout')) {
        if (isMobile) {
          userMessage = 'Camera is taking too long to start. This may be due to poor network or device performance. Please try again.';
        } else {
          userMessage = 'Camera took too long to start. Please try again.';
        }
      } else if (error.message?.includes('Mobile video initialization failed')) {
        userMessage = 'Mobile camera initialization failed. Please ensure you have a stable connection and try again.';
      } else if (typeof error === 'string') {
        userMessage = error;
      } else if (isMobile) {
        // Generic mobile error
        userMessage = 'Camera failed to start on mobile device. Please check permissions and try again.';
      }

      // Show user-friendly error message
      if (this.$toast) {
        this.$toast.error(userMessage);
      }

      // Log error for debugging with device context
      console.error('Camera error context:', {
        error: error,
        userAgent: navigator.userAgent,
        isMobile,
        isIOS,
        isAndroid,
        isPWA,
        permissions: navigator.permissions ? 'supported' : 'not supported'
      });

      // Log error to server
      this.saveError({
        error: String(error),
        context: {
          isMobile,
          isIOS,
          isAndroid,
          isPWA,
          userAgent: navigator.userAgent
        }
      });

      // Show fallback image option if appropriate
      if (shouldShowFallback) {
        setTimeout(() => {
          if (this.$toast) {
            if (isMobile) {
              this.$toast.info('You can still take a placeholder photo by tapping the capture button.');
            } else {
              this.$toast.info('You can still take a placeholder photo by clicking the capture button.');
            }
          }
        }, 2000);
      }

      // For iOS PWA, provide additional guidance
      if (isIOS && isPWA && error.name === 'NotAllowedError') {
        setTimeout(() => {
          if (this.$toast) {
            this.$toast.info('Tip: Add this app to your home screen for better camera access.');
          }
        }, 4000);
      }
    },
  }
}
</script>

<style scoped>
.close-web-camera {
  position: absolute;
  font-size: 34px;
  left: 30px;
  top: 15px;
  text-align: center;
  padding-top: 3px;
  width: 50px;
  height: 50px;
  border-radius: 100px;
  background-color: #fdfdfd;
  z-index: 9999;
}

.user-mode {
  transform: scaleX(-1)
}

.switch-camera {
  position: absolute;
  z-index: 9999;
  cursor: pointer;
  right: 30px;
  transform: translateY(15px);
}

.switch-camera-wrapper {
  background-color: white;
  border-radius: 100px;
  width: 50px;
  height: 50px;
}

.switch-camera .bx-camera {
  color: black;
  font-size: 26px;
  transform: translate(12px, 14px);

}

.switch-camera .switch-number {
  color: black;
  width: 10px;
  transform: translate(34px, -28px);
  font-weight: bold;
  -webkit-user-select: none;
  /* Safari */
  -ms-user-select: none;
  /* IE 10 and IE 11 */
  user-select: none;
  /* Standard syntax */
}

.web-video-containter {
  min-height: 100vh;
  height: auto;
  z-index: 100001;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  background-color: #1C1F3A;
}

/* Mobile fullscreen optimizations */
.mobile-fullscreen {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  height: calc(var(--vh, 1vh) * 100) !important;
  background-color: #1C1F3A !important;
  z-index: 999999 !important;
  overflow: hidden !important;
}

/* Android-specific optimizations */
.android-fullscreen,
.css-fullscreen {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  min-height: 100vh !important;
  max-height: 100vh !important;
  background-color: #1C1F3A !important;
  z-index: 999999 !important;
  overflow: hidden !important;
}

/* Mobile viewport fixes */
@media screen and (max-width: 768px) {
  .web-video-containter {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 100vw !important;
    height: 100vh !important;
    min-height: 100vh !important;
    overflow: hidden !important;
  }

  #preview {
    width: 100vw !important;
    height: 100vh !important;
    object-fit: cover !important;
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
  }
}

.web-video-containter .indicator-entering {
  display: none;
}

@media (orientation: landscape) {
  .web-video-containter {
    width: 100vw;
    height: 100%;
    overflow: hidden;
    min-height: auto;
  }

  .actions {
    flex-direction: column;
    right: 0 !important;
    left: auto !important;
    height: 50vh !important;
    width: 100px;
    padding-top: 0px !important;
  }

  .switch-number {
    transform: translate(24px, -25px) !important;
    font-size: 12px;
  }

  .actions .waves-light {
    position: relative;
    top: -20px;
  }

  .btn-shot {
    margin-left: 0;
    position: relative;
    top: -22px;
    margin-top: 0px;
  }

  .bx-camera {
    font-size: 21px !important;
    transform: translate(9px, 12px) !important;
  }

  .switch-camera-wrapper {
    width: 40px;
    height: 40px;
  }
}

#preview {
  flex: 1;
  width: 100%;
  /*height: 100%;*/
  /*max-height: 100vh;*/
  object-fit: cover;
  height: 100vh;
}

.actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.5rem;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 10vh;
  /* iOS-specific adjustments */
  padding-bottom: env(safe-area-inset-bottom, 1.5rem);
}

/* iOS-specific positioning fixes */
@supports (-webkit-touch-callout: none) {
  .actions {
    bottom: env(safe-area-inset-bottom, 0);
    padding-bottom: 2rem;
    height: calc(10vh + env(safe-area-inset-bottom, 0));
  }
}

/* iPhone 15 specific adjustments */
@media screen and (device-width: 393px) and (device-height: 852px) and (-webkit-device-pixel-ratio: 3) {
  .actions {
    bottom: 20px;
    height: 12vh;
    padding-bottom: 2.5rem;
  }
}

#take-photo {
  width: 50px;
  height: 50px;
  border-radius: 50px;
  background-color: grey;
  border: 3px solid white;
}

.red-take-photo {
  background-color: red !important;
  width: 60px !important;
  height: 60px !important;
}
</style>
